<!-- feedback -->
<main id="feed-back">
  <a id="feedback" [attr.data-tooltip]="'Feedback-page.tooltip-Feedback' | translate" data-target=".feedback-modal-lg"
    data-toggle="modal" style="cursor: pointer">
    <app-icons-free-tools [name]="'feedbackIcon'" />
  </a>
  <div class="modal modal-home centered fade feedback-modal-lg text-center justify-content-center"
    data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="feedback"
    aria-hidden="true">
    <div class="modal-dialog centered modal-lg">
      <div class="modal-content modal-content-feedback">
        <app-icons-free-tools [name]="'crossIcon'" class="cancle" data-dismiss="modal" (click)="clearfeedbackform()" />
        <div class="mt-5">
          <app-icons-free-tools [name]="'messgeIcon'" />

          <p class="feedback-heading mt-4 mb-1">
            {{ "Feedback-page.Share-feedback" | translate }}
          </p>
          <p class="feedback-p">
            {{ "Feedback-page.Share-feedback-detail" | translate }}
          </p>
          <div class="stars">
            <ul class="list-inline rating-list" *ngFor="let star of stars">
              <li #namebutton (click)="countStar(star)" [ngClass]="{ selected: star <= selectedValue }">
                <i class="fa fa-star" id="faStar"> </i>
              </li>
            </ul>
          </div>
        </div>

        <form id="feedBackForm">
          <div class="form-group m-0">
            <label for="form_email" class="feedbackLabel">
              {{ "Feedback-page.Email" | translate }}
            </label>
            <input id="form_email" type="email" name="form_email" class="form-control bd-light" required value=""
              [placeholder]="'Feedback-page.email-placeholder' | translate" onfocus="this.placeholder=''"
              onblur="this.placeholder='Your email address'" [(ngModel)]="form_email" (change)="checkMail()" />
          </div>

          <div class="form-group m-0 mt-3">
            <label for="form_email" class="feedbackLabel">
              {{ "Feedback-page.About-Experience" | translate }}
            </label>
            <textarea id="form_message" name="form_message" class="form-control bd-light scroll" required rows="6"
              style="resize: none"></textarea>
          </div>

          <p class="text-left px-3 success-alter" id="eFsubText2" [ngStyle]="{ color: color }" *ngIf="eFsubIF">
            <i class="fas fa-check-circle mar3" aria-hidden="true"></i>{{ eFsubText2 }}
          </p>
          <p class="text-left m-0 alert-danger" id="dangerAlerts" *ngIf="ifsub" [ngStyle]="{ color: color }">
            <i class="fas fa-check-circle mar3" aria-hidden="true"></i>
            {{ dangerAlerts }}
          </p>
          <div *ngIf="showfeedbackloader" class="progress-feedback mt-2"></div>
          <button type="submit" class="submit w-100 mt-3" value="Send Feedback" id="sendFeedBack"
            (click)="eFormSubmission($event)">
            {{ "Feedback-page.Send-Feedback" | translate }}
          </button>
        </form>
      </div>
    </div>
  </div>
</main>

<section>

  <a (click)="scrollToTop()" *ngIf="shouldShowButton" id="scroll-to-top"
    [attr.data-tooltip]="'Feedback-page.tooltip-Go-top' | translate" style="cursor: pointer;">
    <app-icons-free-tools name="goToTopIcon" />
  </a>
</section>